<template>
  <div class="mb-2" v-if="filterConfig && filterConfig.length > 0">
    <AppFilter
      :filters="filterConfig"
      :filter-submitting="filterSubmitting"
      @filter="handleFilter"
    />
  </div>
</template>
<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { checkHasRole } from '@/@core/utils/roleAccess';
import { ROLES } from '@/constants/roles';

export default {
  components: {
    AppFilter
  },
  mixins: [helper],
  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      customerOptions: []
    };
  },

  computed: {
    filterConfig() {
      return [
        ...(checkHasRole([ROLES.ADMIN])
          ? [
              {
                id: 'customer_id',
                label: 'Customer',
                type: 'select',
                options: this.customerOptions,
                placeholder: 'Customer'
              }
            ]
          : [])
      ];
    }
  },

  methods: {
    handleFilter(filters) {
      this.$emit('filter', filters);
    }
  },

  async created() {
    if (checkHasRole([ROLES.ADMIN])) {
      this.customerOptions = await this.getCustomers({ paginated: false }).then(response => {
        return response.map(customer => ({
          label: customer.name,
          value: customer.id
        }));
      });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
